<template>
  <div :class="['page', isShow ? ['page-show'] : '']">
    <div class="mask" @click="handleClick"></div>

    <Lottie
      class="loading"
      style="width: 175px; height: 125px; margin: auto"
      :options="anim_options"
    />
  </div>
</template>
<script>
import { ref } from "vue";
import _ from "lodash";
import Lottie from "vue-lottie/src/lottie.vue";
// import loading from "@/assets/anim/logo_loading.json";
import loading from "@/assets/anim/loading/data.json";

export default {
  components: {
    Lottie,
  },
  watch: {},
  setup() {
    const isShow = ref(true);

    const anim_options = { animationData: _.cloneDeep(loading) };
    anim_options.animationData.assets.forEach(item => {
      // 适配动态路径
      item.u = '';
      if(item.w && item.h){
        try {
          item.p = require(`@/assets/anim/loading/images/${item.p}`);
        } catch (error) {
          console.error(error);
        }
      }
    })
    const handleClick = () => {
      return;
    };

    return { isShow, anim_options, handleClick };
  },
};
</script>

<style lang="less" scoped>
.page {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  flex-direction: column;
  align-items: center;
  display: none;
  z-index: 9999;

  &-show {
    display: flex;
  }

  .mask {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0);
    top: 0;
    left: 0;
  }

  .loading {
    // width: 125px !important;
    // height: 125px !important;
    // margin: auto !important;
  }
}
</style>
